import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import * as SurveyKo from "survey-knockout";
import * as SurveyCreator from "survey-creator";
import * as widgets from "surveyjs-widgets";
import { init as initCustomWidget } from "../customwidget";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from 'primeng/api';
//import json from "../../../assets/survey.json"; 

// widgets.icheck(SurveyKo);
// widgets.select2(SurveyKo);
// widgets.inputmask(SurveyKo);
// widgets.jquerybarrating(SurveyKo);
// widgets.jqueryuidatepicker(SurveyKo);
// widgets.nouislider(SurveyKo);
//widgets.select2tagbox(SurveyKo);
//widgets.signaturepad(SurveyKo);
//widgets.sortablejs(SurveyKo);
// widgets.ckeditor(SurveyKo);
// widgets.autocomplete(SurveyKo);
// widgets.bootstrapslider(SurveyKo);
// //widgets.emotionsratings(SurveyKo);
//initCustomWidget(SurveyKo);

SurveyCreator.StylesManager.applyTheme("default");





@Component({
  selector: 'app-editarformulario',
  templateUrl: './editarformulario.component.html',
  styleUrls: ['./editarformulario.component.css']
})
export class EditarformularioComponent implements OnInit {

  grabaraudio: boolean = false; // Propiedad para ngModel
  agregarsujeto: boolean = false; // Propiedad para ngModel
  campoidentificador: string = ''; // Propiedad para ngModel
  campodescripcion: string = ''; // Propiedad para ngModel
    
    /**
     * Representa un objeto JSON.
     */
    json;
    /**
     * Representa el objeto creador de encuestas.
     */
    surveyCreator;

    /**
     * El identificador único para el componente formulario.
     */
    id='192';
    /**
     * Representa el nombre de una persona.
     */
    Nombre;
    /**
     * Descripción de la variable Descripcion.
     */
    Descripcion;


    /**
     * Representa los datos del formulario para el componente formulario.
     */
    formulario = {};

    /**
     * Crea una instancia del componente FormularioComponent.
     * @param data - El servicio de datos.
     * @param route - La ruta activada.
     */
    constructor(public data: DataService, private route: ActivatedRoute, private router: Router, private messageService: MessageService) {

        this.id = this.route.snapshot.paramMap.get('id');
        //this.id = "67a0d43323091505dad1e0ce";
        console.log("&&&&&&&&&&&&&&&&&&& id &&&&&&&&&&&&&&&&&&");
        console.log(this.id);

    }


    

    /**
     * Inicializa el componente y recupera los datos del formulario.
     */
    ngOnInit(): void {

      if (this.id==null) {
        this.json={};
      } 
      else {
        console.log("&&&&&&&&&&&&&&&&&  Obteniendo resultados  &&&&&&&&&&&&&&&&&");
        console.log(this.id);

        this.data.ObtenerFormulario(this.id).subscribe(x => {
            this.formulario = x;

            console.log("&&&&&&&&&&&&&&&&&&  1Resultado obtenido1  &&&&&&&&&&&&&&&&&&&");
            console.log(x);

            
            this.json = this.formulario["Definicion"];
            this.Nombre = this.formulario["Definicion"]["title"];
            this.Descripcion = this.formulario["Definicion"]["description"];

            //this.grabaraudio = this.formulario["grabaraudio"];
            this.agregarsujeto = this.formulario["AgregarSujeto"];
            this.campoidentificador = this.formulario["CampoIdentificador"];
            this.campodescripcion = this.formulario["CampoDescripcion"];


            SurveyCreator.StylesManager.applyTheme("winter");

            SurveyCreator.editorLocalization.currentLocale = "es";
            let options = {
                showEmbededSurveyTab: true,
                showJSONEditorTab: true,
                showTestSurveyTab: true,
                showEmbeddedSurveyTab: false,
                generateValidJSON: true,
                showPropertyGrid: false,
                //questionTypes: ["text", "checkbox", "radiogroup", "dropdown"] 
            };
            this.surveyCreator = new SurveyCreator.SurveyCreator(
                "surveyCreatorContainer",
                options
            );
      
      
            this.surveyCreator.text = JSON.stringify(this.json);
      
            console.log("===============formulario=====================");
            console.log(JSON.stringify(this.json));
      
      
            this.surveyCreator.saveSurveyFunc = this.saveMySurvey;
      
            SurveyKo.Survey
      
            console.log("=========================================================Encuesta====================================================");
            console.log(SurveyKo);
      
              // if (window.location.href.substr(-6) !="loaded") {
              //     window.location.href = window.location.href + '#loaded';
              //     window.location.reload();
              // }



        })
      }

      

    }

    /**
     * Guarda el formulario de la encuesta.
     */
    saveMySurvey = () => {
        console.log("guardando");
        console.log(JSON.stringify(this.surveyCreator.text));

        console.log("this.id");
        console.log(this.id);
        console.log("this.json");
        console.log(this.json);
        console.log("this.grabaraudio");
        console.log(this.grabaraudio);
        console.log("this.agregarsujeto");
        console.log(this.agregarsujeto);
        console.log("this.campoidentificador");
        console.log(this.campoidentificador);
        console.log("this.campodescripcion");
        console.log(this.campodescripcion);

        var definicion=JSON.parse(this.surveyCreator.text);



        this.data.GuardarFormulario(this.id, this.surveyCreator.text, this.agregarsujeto, this.campoidentificador, this.campodescripcion).subscribe(x => {
            this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Formulario guardado'});
        })

    };

    reload = ()=>{
        window.location.reload();
    }







}
